import {
  pushViewAction,
  setContractQueryAction,
} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import {
  dateFormatter,
  formatCurrency,
  paymentRemainDays,
} from '../../../utils/util';

import {Box, Button, Card, CardContent, Typography} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import './nextInstallment.css';

const NextInstallment = (props) => {
  const ALLCONTRACT = 'ALL_CONTRACTS';
  const {t} = useTranslation();

  const renderRemainingDays = (dueDate) => {
    let remainingDay = paymentRemainDays(dueDate);
    return remainingDay === 0
      ? t('DUE_TODAY')
      : t('DUE_IN') + ' ' + remainingDay + ' ' + t('DAYS');
  };
  const handleRedirect = () => {
    if (props.contractCount > 1) {
      appStore.dispatch(setContractQueryAction(ALLCONTRACT));
    }
    appStore.dispatch(pushViewAction('paymentSchedule'));
  };

  const accountSummary = () => (
    <div id="accountSummaryBox">
      <Box>
        <Card className="accountSummaryCustomCard">
          <CardContent className="cardContentCustom">
            <Typography className="nextInstallmentSubTitle">
              {t('NEXT_INSTALLMENT')}
            </Typography>
            <Typography className="installmentAmount">
              {formatCurrency(props.nextInstallment?.installmentAmount)}
            </Typography>
            <Typography className="nextInstallmentLowerSubTitle">
              {props.nextInstallment &&
                renderRemainingDays(props.nextInstallment.paymentDueDate)}
            </Typography>
          </CardContent>
          <CardContent className="cardContentCustom">
            <Typography className="nextInstallmentSubTitle right-align">
              {t('DUE_DATE')}
            </Typography>
            <Typography className="paymentDueDate right-align">
              {dateFormatter(props.nextInstallment?.paymentDueDate)}
            </Typography>
          </CardContent>
          <Button
            type="submit"
            disabled={false}
            id="viewAccountButton"
            variant="primary"
            onClick={handleRedirect}
          >
            {t('VIEW_ACCOUNT')}
          </Button>
        </Card>
      </Box>
    </div>
  );
  return (
    <div className="nextInstallmentCard" id={'nextInstallmentCard'}>
      {accountSummary()}
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    contractCount: state.appStates.contractNumbers?.contractCounts,
    nextInstallment:
      state.appStates.paymentSchedule?.paymentSchedules?.nextInstallment,
    paymentScheduleError: state.appStates.paymentScheduleError,
  };
};
export default connect(mapStateToProps)(NextInstallment);
